import { render, staticRenderFns } from "./Animal.vue?vue&type=template&id=57aba799&scoped=true"
import script from "./Animal.vue?vue&type=script&lang=js"
export * from "./Animal.vue?vue&type=script&lang=js"
import style0 from "./Animal.vue?vue&type=style&index=0&id=57aba799&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aba799",
  null
  
)

export default component.exports